import { Component, OnInit } from '@angular/core';
import { Grupa, GrupeService } from '../grupe.service';
import { ModulService } from '../modul.service';
import { TerminiFilter, TerminiRez, TerminiRezGrp, TerminiService } from '../termini.service';
import { KalendarService } from '../kalendar.service';

@Component({
  selector: 'app-termini-pregled-sidebar',
  templateUrl: './termini-pregled-sidebar.component.html',
  styleUrls: ['./termini-pregled-sidebar.component.scss']
})
export class TerminiPregledSidebarComponent implements OnInit {

  constructor(
    public srvGrupe: GrupeService,
    public mod: ModulService,
    public srvTermini: TerminiService,
    public srvKalendar: KalendarService
  ) { }


  ngOnInit(): void {

    this.srvTermini.napraviFrmTerminFilter((val: TerminiFilter) => {
      this.prikazi();
    });

  }

  //prikaz rezultata
  prikazi() {
    this.srvTermini.filterTermini(this.srvTermini.frmTerminFilter.value, (rez: TerminiRezGrp[]) => {
      console.log(rez);
      this.srvTermini.objTermini = rez;
    });
  }

  //Odabir poslovne jedinice
  odabirPoslovneJedinice() {
    console.log(this.srvTermini.frmTerminFilter.value);
    this.srvTermini.frmTerminFilter.get('grpID').setValue('0');
    this.srvGrupe.objGrupe = null;
    this.srvGrupe.grupeByPosJed(this.srvTermini.frmTerminFilter.get('pjedID').value, (rez: Grupa[]) => {
      this.srvGrupe.objGrupe = rez;
    });
  }

}
